<!--------------------------------------------Updated Content-------------------------------------------->
<app-nav-menu></app-nav-menu>
<!--------------------------------------------Updated Content-------------------------------------------->
<dx-load-panel [(visible)]="isLoadPanelVisible">
</dx-load-panel>
<p-toast></p-toast>
<p-confirmDialog>
  <ng-template pTemplate="message" let-message>
    <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
      <i class="pi pi-exclamation-circle text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmDialog>
<p-dialog [(visible)]="refreshTktopen" [style]="{ width: '50vw' }" [draggable]="false" [modal]="true"
  [closable]="false">

  <div style=" display: flex; width: 100%; justify-content: center; align-items: center; flex-direction: column;">
    <p style="font-weight: bold; font-size: 18px; width: 100% !important; word-wrap: break-word;"> Error:{{errorIssueticketMessage}}</p>
    <p style="padding-top:5px"> Please Refresh the Page!</p>
    <div class="">
      <div>
        <button class="yesButton" style="margin-left:0px !important" (click)="refreshPageClick()">Yes, Resfresh it!</button>
      </div>

    </div>
  </div>


</p-dialog>
<p-dialog header="Message" [(visible)]="messageShowpop" [style]="{ width: '25rem' }" [modal]="true">
  <span class="p-text-secondary block mb-5" style="color:#35a117;font-size:14px">{{messageshow}}</span>
</p-dialog>
@if (loadervisible) {
  <div style="width: 100%; height: 105vh; position: fixed; background:#000000e8; z-index: 15000;top:0px; ">
    <div class="loaderforPassenger">
      Loading
      <span class="loadspan"></span>
    </div>
  </div>
}
<div style="display:none">
  <dx-data-grid style="display:none" #gridContainer3
    [dataSource]=""
    keyExpr="ID"
    [showBorders]="true">
  </dx-data-grid>
</div>
<main class="main">
  <!--<div id="overlaySpinner">
  <div class="spinner-border text-primary " *ngIf="ticketIssuanceService" style="height: 5rem; width: 5rem; margin-top: 21rem; margin-left: 44rem;"></div>
</div>-->
<ng-template #emailpopupwithfinance let-modal>
  <!--with-->
  <div class="modal-headeremail">

    <h2 class="textpopupemail">Email With Itinerary</h2>
    <span class="closepopupemail" (click)="modal.dismiss()">&times;</span>
  </div>
  <div class="modal-bodyemail">
    <div style="margin-top:10px">
      <form class="form-line-active popuplabel">
        <div class="form-row ">
          <div class="col-md-10 mb-3">
            <label for="validationServer02">Email</label>
            <input type="email" class="form-control withemailIterniary" name="customerEmail" [(ngModel)]="ticketEmailObj.customerEmail" (blur)="multipleEmailRegex(ticketEmailObj.customerEmail)" placeholder="Please Enter Email" multiple>
            <span class="tooltiptext" id="message1"></span>
            <span class="messageRequiredCreate" id="messageEmail"></span>
          </div>

        </div>
        <div class="form-row">
          <div class="col-md-10 mb-3">
            <span class="emailnotes">
              Note:
            </span>
            <span class="emailnote">
              "If You Want To Enter Multiple Emails Please follow this pattern"
            </span>
            <span class="emailnotesmsg">
              (e.g:person&#64;abc.com,person2&#64;abc.com.....)
            </span>
          </div>
        </div>
        <div class="form-row ">
          <div class="col-md-7 mb-3">
          </div>
          <div class="col-md-12 mb-3 d-flex justify-content-between gap-1">
            <button class="button-iMAGE" (click)="emailItineraryFinance(true,'null')" role="button">Send Email</button>
            <button class="button-iMAGE" (click)="emailItineraryFinanceOld(true,'null')" role="button">Send Email(Old)</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<ng-template #emailpopupwithoutfinance let-modal>
  <!--without-->
  <div class="modal-headeremail">

    <h2 class="textpopupemail"> Email Without Itinerary</h2>
    <span class="closepopupemail" (click)="modal.dismiss()">&times;</span>
  </div>
  <div class="modal-bodyemail">
    <div style="margin-top:10px">
      <form class="form-line-active popuplabel">
        <div class="form-row ">
          <div class="col-md-10 mb-3">
            <label for="validationServer02">Email</label>
            <input type="email" class="form-control" id="withoutemailIterniary" (blur)="multipleEmailRegex(ticketEmailObj.customerEmail)" [(ngModel)]="ticketEmailObj.customerEmail" name="emailfinancewithout" placeholder="Please Enter Email">
            <span class="tooltiptext" id="message1"></span>
            <span class="messageRequiredCreate" id="messageEmail"></span>
          </div>

        </div>
        <div class="form-row">
          <div class="col-md-10 mb-3">
            <span class="emailnotes">

              Note:
            </span>
            <span class="emailnote">

              "If You Want To Enter Multiple Emails Please follow this pattern"
            </span>
            <span class="emailnotesmsg">
              (e.g:person&#64;abc.com,person2&#64;abc.com.....)
            </span>
            <span>

            </span>
          </div>
        </div>
        <div class="form-row ">
          <div class="col-md-12 mb-3 d-flex justify-content-between gap-1">
            <button class="button-iMAGE" (click)="emailItineraryFinance(false,'all')" role="button">Send Email (All)</button>
            <button class="button-iMAGE" (click)="emailItineraryFinance(false,'each')" role="button">Send Email (Each)</button>
          </div>
          <div class="col-md-12 mb-3">
            <button class="button-iMAGE" (click)="emailItineraryFinanceOld(false,'all')" role="button">Send Email Without (Old)</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>




<!--<ng-template #emailpopupwithfinance let-modal>-->
<!--with-->
<!--<div class="modal-headeremail">

<h2 class="textpopupemail">Email With Itinerary</h2>
<span class="closepopupemail" (click)="modal.dismiss()">&times;</span>
</div>
<div class="modal-bodyemail">
  <div style="margin-top:10px">
    <form class="form-line-active popuplabel">
      <div class="form-row ">
        <div class="col-md-10 mb-3">
          <label for="validationServer02">Email</label>
          <input type="email" class="form-control withemailIterniary" name="customerEmail" [(ngModel)]="ticketEmailObj.customerEmail" (blur)="multipleEmailRegex(ticketEmailObj.customerEmail)" placeholder="Please Enter Email" multiple>
          <span class="tooltiptext" id="message1"></span>
          <span class="messageRequiredCreate" id="messageEmail"></span>
        </div>

      </div>
      <div class="form-row">
        <div class="col-md-10 mb-3">
          <span class="emailnotes">
            Note:
          </span>
          <span class="emailnote">
            "If You Want To Enter Multiple Emails Please follow this pattern"
          </span>
          <span class="emailnotesmsg">
            (e.g:person@abc.com,person2@abc.com.....)
          </span>
        </div>
      </div>
      <div class="form-row ">
        <div class="col-md-7 mb-3">
        </div>
        <div class="col-md-5 mb-3">
          <button class="button-iMAGE" (click)="emailItineraryFinance(true)" role="button">Send Email</button>
        </div>
      </div>
    </form>
  </div>
</div>-->
<!--<div id="employeeInfo" *ngIf="grid.selectedRowKeys.length">
<input [value]="grid.instance.getSelectedRowsData()[0].lastName" />
</div>-->
<!--</ng-template>
<ng-template #emailpopupwithoutfinance let-modal>-->
  <!--without-->
  <!--<div class="modal-headeremail">

  <h2 class="textpopupemail"> Email Without Itinerary</h2>
  <span class="closepopupemail" (click)="modal.dismiss()">&times;</span>
</div>
<div class="modal-bodyemail">
  <div style="margin-top:10px">
    <form class="form-line-active popuplabel">
      <div class="form-row ">
        <div class="col-md-10 mb-3">
          <label for="validationServer02">Email</label>
          <input type="email" class="form-control" id="withoutemailIterniary" (blur)="multipleEmailRegex(ticketEmailObj.customerEmail)" [(ngModel)]="ticketEmailObj.customerEmail" name="emailfinancewithout" placeholder="Please Enter Email">
          <span class="tooltiptext" id="message1"></span>
          <span class="messageRequiredCreate" id="messageEmail"></span>
        </div>

      </div>
      <div class="form-row">
        <div class="col-md-10 mb-3">
          <span class="emailnotes">

            Note:
          </span>
          <span class="emailnote">

            "If You Want To Enter Multiple Emails Please follow this pattern"
          </span>
          <span class="emailnotesmsg">
            (e.g:person@abc.com,person2@abc.com.....)
          </span>
          <span>

          </span>
        </div>
      </div>
      <div class="form-row ">
        <div class="col-md-7 mb-3">
        </div>
        <div class="col-md-5 mb-3">

          <button class="button-iMAGE" (click)="emailItineraryFinance(false)" role="button">Send Email</button>
        </div>
      </div>
    </form>
  </div>-->
  <!--<button type="submit" (click)="SelectedRows()" class="profilesearchbutton">Submit</button>-->
<!--</div>-->
<!--<div id="employeeInfo" *ngIf="grid.selectedRowKeys.length">
<input [value]="grid.instance.getSelectedRowsData()[0].lastName" />
</div>-->
<!--</ng-template>-->
<!--<div id="loading_container">
<div class="spinner-border" id="loadingSp" role="status">
  <span class="sr-only" id="overlaySpinner"></span>
</div>
</div>-->
<div class="easeoutin">
  <ng-template #ancierror let-modal>



    <div class="modal-success_new new_class_pop">
      <div style="display: flex; align-items: center; justify-content: center; padding: 12px; ">
        <img class="sucesspopup_img" src="assets/img/icons8-info-94.png" />
      </div>
      <div style="display: flex; align-items: center; justify-content: center; padding: 5px; ">
        <p class="innerhtmlofmodal_new">{{ANCIMsg}}</p>
      </div>
      <div style="display: flex; align-items: center; justify-content: center; padding: 5px; ">
        <button class="OKButton" (click)="modal.dismiss()">Ok</button>
      </div>

    </div>



  </ng-template>
</div>
<div class="container cms_main">

  <div class="cms_card">
    @if (offlinetoOnlineproperty.TicketIssueReqFromOffline) {
      <div class="container newmarker">
        <div class="alert alert-warning alert-dismissible">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong id="makerhead">Online booking done with this Agency Id: <span style="font-weight:800">{{onlineRequestfromOfflineAgencyId}}</span>, Against this Booking Id: <span style="font-weight:800">{{bookingID}}</span>, Offline Request for Ticket Issuance</strong>
        </div>
      </div>
    }
    @if (offlinetoOnlineproperty.VoidReqFromOffline) {
      <div class="container newmarker">
        <div class="alert alert-warning alert-dismissible">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong id="makerhead">Online booking done with this Agency Id: <span style="font-weight:800">{{onlineRequestfromOfflineAgencyId}}</span>, Against this Booking Id: <span style="font-weight:800">{{bookingID}}</span>, Offline Request for Void Ticket</strong>
        </div>
      </div>
    }
    @if (offlinetoOnlineproperty.PNRReqFromOffline) {
      <div class="container newmarker">
        <div class="alert alert-warning alert-dismissible">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong id="makerhead">Online booking done with this Agency Id: <span style="font-weight:800">{{onlineRequestfromOfflineAgencyId}}</span>, Against this Booking Id: <span style="font-weight:800">{{bookingID}}</span>, Offline Request for PNR Cancel</strong>
        </div>
      </div>
    }
    @if (offlinetoOnlineproperty.RefundReqFromOffline) {
      <div class="container newmarker">
        <div class="alert alert-warning alert-dismissible">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong id="makerhead">Online booking done with this Agency Id: <span style="font-weight:800">{{onlineRequestfromOfflineAgencyId}}</span>, Against this Booking Id: <span style="font-weight:800">{{bookingID}}</span>, Offline Request for Refund Ticket</strong>
        </div>
      </div>
    }

    <div style="display: flex; display: flex; justify-content: center; align-items: center; background-color: #c0c0c04a; border-radius: 5px; padding: 5px;margin:5px">
      <h4 style="color:black;font-weight:bold;letter-spacing:2px;">{{bookingInfo.providerCode}}</h4>
    </div>

    @if (agencyID === 'AG01') {
      <div class="inner_body my-2">
        <div class="cms_card-heading">Select Company</div>
        <div class="row justify-content-center">
          <div class="form-group">
            <p-select id="fromrtcc"
              name="fromrt"
              placeholder="Select Company"
              [options]="GetAllUserBackCompanyCustomerCode"
              optionLabel="companyName"
              optionValue="userId"
              [filter]="true"
              filterBy="companyName"
              required [(ngModel)]="selectedBackCompanyUserId" #fromrt="ngModel">
            </p-select>
            @if (fromrt.invalid && fromrt.touched) {
              <div style="color:red">
                Company is required
              </div>
            }
          </div>
        </div>
      </div>
    }

    <div class="upper_row">

      <div class="inner_body card_width2">
        <div class="cms_card-heading">Trip</div>
        @for (city of newsectorInfo; track city) {
          <div class="trip_details">{{city.fromCity}} To {{city.toCity}}</div>
        }
        <div class="trip_links">
          <!--<button class="trip_link link_but" (click)="sendEmail()">Email Itinerary</button>-->
          <!--<a class="trip_link" routerLink="/">Fare Rules</a> |-->
          <span class="trip_links">
            <button class="trip_link link_but dropdown-toggle" type="button" id="btnPrint" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Email Itinerary
            </button>
            <span class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item" (click)="popupEmailItineraryFinance(emailpopupwithfinance)">With Finances</button>
              <button class="dropdown-item" (click)=" popupEmailItineraryWithoutFinance(emailpopupwithoutfinance)">Without Finances</button>
            </span>
          </span>
          <!--<span class="trip_links">
          <button class="trip_link link_but dropdown-toggle" type="button" id="btnPrint" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Print Itinerary
          </button>
          <span class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <button class="dropdown-item" (click)="printItinerary1(true)">With Finances</button>
            <button class="dropdown-item" (click)="printItinerary1(false)">Without Finances</button>
          </span>
        </span>-->

        <div class="trip_links">
          <button class="trip_link link_but dropdown-toggle" type="button" id="ticketPrint" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Print Itinerary
          </button>
          <div class="dropdown-menu" aria-labelledby="ticketPrint">
            <button class="dropdown-item" (click)="printItinerary1(true,'null')">With Finances</button>
            <button class="dropdown-item" (click)="printItinerary1Old(true,'null')">With Finances(Old)</button>
            <!--<button class="dropdown-item" (click)="printItinerary1(false)">Without Finances</button>-->
            <div class="dropdown-divider"></div>
            <div class="dropdown-submenu">
              <button class="dropdown-item dropdown-toggle">Without Finances</button>
              <div class="dropdown-menu">
                <button class="dropdown-item" (click)="printItinerary1(false,'each')">Without Each</button>
                <div class="dropdown-divider"></div>
                <button class="dropdown-item" (click)="printItinerary1(false,'all')">Without All</button>
              </div>
            </div>
            <div class="dropdown-submenu">
              <button class="dropdown-item" (click)="printItinerary1Old(false,'each')">Without Finances(Old)</button>
            </div>
          </div>
        </div>

        <div id="btn_loading_container">
          <div class="spinner-border" id="btn_loadingSp" role="status">
            <span class="sr-only" id="btn_overlaySpinner"></span>
          </div>
        </div>

        <br />
        <!--<button class="trip_link link_but" (click)="editPassport()">Edit Passport Info</button>-->

      </div>

      @if (buttonsHideIfEmiratesOccur ==  false) {
        <div class="lower_buttons">
          <!--<button class="button-87" id="issueTicket" *ngIf="checkbuttonhideshow.ticketissuebtn" [disabled]="buttonagreed_Issue" (click)="issuetktopen(issueticket)"> <span *ngIf="bookingInfo.exchangeCheck">Re</span>Issue Ticket</button>-->
          @if (checkbuttonhideshow.ticketissuebtn) {
          <button class="button-87" id="issueTicket" [disabled]="buttonagreed_Issue" (click)="issuetktopen(issueticket)">{{checkIssueTicket ? (bookingInfo.exchangeCheck ? 'ReIssue Ticket' : 'Issue Ticket') : 'Request to Issue' }} </button>
          }


          @if(checkbuttonhideshow.ticketissuebtn && showRepricebtn)
          {
             <button class="button-87" id="repriceTicket" [disabled]="buttonagreed_Reprice" (click)="repricetktopen(repriceticket)">Reprice</button>
          }



          <!--<button class="button-87" id="issueTicket" *ngIf="showAddDetailButton && checkbuttonhideshow.ticketissuebtn" (click)="openPassportDetailsModel(addPassengerDetails)"> Add Details</button>-->
          @if (checkbuttonhideshow.cancelbtn) {
          <button class="button-87" id="cancelPNR" [disabled]="buttonagreed_cancel" (click)="pnrCancelopen(pnrtkt)">
            @if (bookingInfo.exchangeCheck) {
            <span>Exchange</span>
            } Cancel PNR
          </button>
          }
          @if (checkbuttonhideshow.voidbtn) {
          <button class="button-87" id="voidTicket" [disabled]="buttonagreed_void" (click)="voidTktopen(voidtkt)">Void Ticket</button>
          }
          @if (checkbuttonhideshow.refundbtn) {
          <button class="button-87" id="refundTicket" [disabled]="buttonagreed_refund" (click)="RefundPopupForConfirmation(rfndtkt)">
            @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==2) {
            <span>Exchange</span>
            }Refund
          </button>
          }
          @if (checkbuttonhideshow.ancibtn) {
          <button class="button-87" (click)="hititAnciclick()">
            @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==2) {
            <span>Exchange</span>
            } Post ANCI Add
          </button>
          }
          @if (showPostInvoiceBtnForBranches) {
          <button class="button-87" (click)="openServiceChargesModel(addServiceCharges)"> Add Service Charges</button>
          }
          @if (checkbuttonhideshow.ssrIssueTicketbtn) {
          <button class="button-87" (click)="ssrIssueTicketHitit()">
            @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==2) {
            <span>Exchange</span>
            } SSR Issue
          </button>
          }
          @if (checkbuttonhideshow.modifybtn && bookingInfo.providerCode !='FZ') {
          <label class="dropdown" id="Modify">
            <span class="dd-button button-87">
              Modify Booking<i class="fas fa-angle-down" style="margin-left: 6px;" aria-hidden="true"></i>
            </span>
            <input type="checkbox" class="dd-input" id="test">
            <ul class="dd-menu">
              @if (!bookingInfo.exchangeCheck && bookingStatus !='Booked') {
              <li (click)="ModifyAirAiternary()">Air Aiternary</li>
              }
              @if (bookingInfo.providerCode =='FZ' && partialExchange == true) {
              <li (click)="ModifyAirAiternary()">Air Aiternary</li>
              }
              @if (bookingInfo.providerCode !='AI'&& bookingInfo.providerCode !='SG'&&bookingInfo.providerCode !='EK' ) {
              <li (click)="ModifyPassengerInfo()">Passenger Info</li>
              }
              @if (checkbuttonhideshow.removePassengerBtn && bookingInfo.bookingPassengerInfoProperties.length >1) {
              <li (click)="RedirecttoRemovePassenger()">Remove Passenger</li>
              }
              @if (bookingInfo.bookingStatus == 1 && bookingInfo.providerCode == 'PA') {
              <li (click)="airBlueAnciclick()">Add Seat</li>
              }
            </ul>
          </label>
          }
        </div>
      }
      @if (buttonsHideIfEmiratesOccur) {
        <div class="lower_buttons">
          <label class="dropdown" id="Modify">
            <span class="dd-button button-87">
              Exchanged Booking<i class="fas fa-angle-down" style="margin-left: 6px;" aria-hidden="true"></i>
            </span>
            <input type="checkbox" class="dd-input" id="test">
            <ul class="dd-menu">
              @if (checkbuttonhideshow.exchangevoidbtn) {
                <li id="voidTicket" (click)="ExchangeEmirates(emiratesEnumsForExchangedDivide.exchangedtktvoidpopOpen)">Void Ticket</li>
              }
              @if (checkbuttonhideshow.exchangeancibtn) {
                <li (click)="ExchangeEmirates(emiratesEnumsForExchangedDivide.exchangedAnciAvail)">Post Add Ancillaray</li>
              }
              @if (checkbuttonhideshow.exchangessrIssueTicketbtn) {
                <li (click)="ExchangeEmirates(emiratesEnumsForExchangedDivide.exchangedIssueSSRTicket)">SSR Issue</li>
              }
              @if (checkbuttonhideshow.exchangerefundbtn) {
                <li id="refundTicket" (click)="ExchangeEmirates(emiratesEnumsForExchangedDivide.exchangedtktrefundpopOpen)">Refund</li>
              }
            </ul>
          </label>
          <label class="dropdown" id="Modify">
            <span class="dd-button button-87">
              Initial Booking<i class="fas fa-angle-down" style="margin-left: 6px;" aria-hidden="true"></i>
            </span>
            <input type="checkbox" class="dd-input" id="test">
            <ul class="dd-menu">
              @if (checkbuttonhideshow.voidbtn) {
                <li (click)="ExchangeEmirates(emiratesEnumsForExchangedDivide.initialtktvoidpopOpen)">Void Ticket</li>
              }
              @if (checkbuttonhideshow.ancibtn) {
                <li (click)="ExchangeEmirates(emiratesEnumsForExchangedDivide.initialAnciAvail)">Post Add Ancillaray</li>
              }
              @if (checkbuttonhideshow.ssrIssueTicketbtn) {
                <li (click)="ExchangeEmirates(emiratesEnumsForExchangedDivide.initialIssueSSRTicket)">SSR Issue</li>
              }
              @if (checkbuttonhideshow.refundbtn) {
                <li id="refundTicket" (click)="ExchangeEmirates(emiratesEnumsForExchangedDivide.initialtktrefundpopOpen)">Refund</li>
              }
            </ul>
          </label>
        </div>
      }
    </div>

    <div class="inner_body card_width2">
      <div class="cms_card-heading">Booking Information</div>
      <div class="main_info">
        <div class="info_row">
          <div class="info_name">Booking ID :</div>
          <div class="info_result">{{bookingInfo.bookingID}}</div>
        </div>
        <div class="info_row">
          <div class="info_name">Booking Date :</div>
          <div class="info_result">{{bookingInfo.bookingDate | date:'fullDate'}}</div>
        </div>
        <div class="info_row">
          <div class="info_name">
            @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==1) {
              <span>Current </span>
            }
            @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==2 && !buttonsHideIfEmiratesOccur) {
              <span>Old </span>
            }
            @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==2 && buttonsHideIfEmiratesOccur) {
              <span>Initial </span>
              }Status :
            </div>
            <div class="info_result">{{bookingStatus}}</div>
          </div>
          <div class="info_row">
            <div class="info_name">PNR :</div>
            <div class="info_result">{{bookingInfo.pnr}}</div>
          </div>

          <div class="info_row" hidden="hidden">
            <div class="info_name">Total Sale Amount :</div>
            <div class="info_result">{{currency}} {{bookingInfo.totalAmount.toFixed(2)}}</div>
          </div>
          <div class="info_row">
            <div class="info_name">Total Purchase Amount :</div>
            <div class="info_result">{{currency}} {{nettosupplierbase.toFixed(2)}}</div>
          </div>
          @if (refundamount) {
            <div class="info_row">
              <div class="info_name">Net Refund Customer:</div>
              @if (bookingInfo.providerCode !='SG') {
                <div class="info_result">{{currency}} {{bookingInfo.totalrefundAmountCustomer}}</div>
              }
              @if (bookingInfo.providerCode =='SG') {
                <div class="info_result">{{currency}} {{bookingInfo.totalrefundAmount}}</div>
              }
            </div>
          }
          @if (FZmodification) {
            <div class="info_row">
              <div class="info_name">Reservation Balance:</div>
              @if (bookingInfo.providerCode =='FZ') {
                <div class="info_result">{{currency}} {{netpayamount}}</div>
              }
            </div>
          }
          @if (ChangeCost) {
            <div class="info_row">
              <div class="info_name">Change Cost :</div>
              <div class="info_result">{{currency}} {{ChangePrice}}</div>
            </div>
          }
          @if (refundamount && bookingInfo.providerCode !='SG') {
            <div class="info_row">
              <div class="info_name">Net Refund Purchase:</div>
              <div class="info_result">{{currency}} {{bookingInfo.totalrefundAmount}}</div>
            </div>
          }
          @if (bookingInfo.exchangeCheck && !buttonsHideIfEmiratesOccur) {
            <div class="info_row">
              <div class="info_name"> @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus===2) {
                <span>Current </span>
              }Exchanged Status:</div>
              @if (bookingInfo.exchangedBookingStatus === 1) {
                <div class="info_result">Booked</div>
              }
              @if (bookingInfo.exchangedBookingStatus === 2) {
                <div class="info_result">Ticketed</div>
              }
              @if (bookingInfo.exchangedBookingStatus === 4) {
                <div class="info_result">Void</div>
              }
              @if (bookingInfo.exchangedBookingStatus === 7) {
                <div class="info_result">Refund</div>
              }
              @if (bookingInfo.exchangedBookingStatus === 3) {
                <div class="info_result">Cancelled</div>
              }
            </div>
          }

          @if (bookingInfo.exchangeCheck && buttonsHideIfEmiratesOccur) {
            <div class="cms_card-heading">Exchanged Booking Information</div>
          }
          @if (bookingInfo.exchangeCheck && buttonsHideIfEmiratesOccur) {
            <div class="info_row">
              <div class="info_name"> @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus===2) {
                <span>Current </span>
              }Exchanged Status:</div>
              @if (bookingInfo.exchangedBookingStatus === 1) {
                <div class="info_result">Booked</div>
              }
              @if (bookingInfo.exchangedBookingStatus === 2) {
                <div class="info_result">Ticketed</div>
              }
              @if (bookingInfo.exchangedBookingStatus === 4) {
                <div class="info_result">Void</div>
              }
              @if (bookingInfo.exchangedBookingStatus === 7) {
                <div class="info_result">Refund</div>
              }
              @if (bookingInfo.exchangedBookingStatus === 3) {
                <div class="info_result">Cancelled</div>
              }
            </div>
          }
          @if (bookingInfo.exchangeCheck && buttonsHideIfEmiratesOccur) {
            <div class="info_row">
              <div class="info_name">Exchange PNR:</div>
              <div class="info_result">{{bookingInfo.exchangebookingId}}</div>
            </div>
          }
          @if (bookingInfo.exchangeCheck) {
            <div class="info_row">
              <div class="info_name">Remaining Amount to be Paid:</div>
              <div class="info_result">{{currency}} {{netpayamount.toFixed(2)}}</div>
            </div>
          }
          @if (bookingInfo.exchangeCheck ) {
            <div class="info_row">
              <div class="info_name">Net Purchased Exchanged Amount:</div>
              <div class="info_result">{{currency}} {{exchangenettosupplierbase.toFixed(2)}}</div>
            </div>
          }

        </div>
      </div>

    </div>


    <div class="inner_body my-2">
      <div class="cms_card-heading">
        @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==2 && !buttonsHideIfEmiratesOccur) {
          <span>Old </span>
        }
        @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==2 && buttonsHideIfEmiratesOccur) {
          <span>Initial </span>
        }
        @if (bookingInfo.exchangeCheck&& bookingInfo.exchangedBookingStatus==1) {
          <span>Current </span>
          }Flights Details
        </div>
        @for (flight of newsectorInfo; track flight; let i = $index) {
          <div>
            <div class="details_heading_topbar">
              <div class="from-to">
                <span style="letter-spacing:0.7px">
                  <i class="uil uil-plane head_icon"></i>
                  {{flight.fromAirport}} TO {{flight.toAirport}}
                </span>
              </div>
              <div class="stops"><span style="letter-spacing:0.7px">{{flight.noOfStops}} Stop(s)</span></div>
            </div>
            <div class="details_heading">
              <div class="padding_class1">
                <div class="margin_top" style="margin-top:5px"><img style="max-width:90px;height:50px" src="assets/img/{{flight.airlineLogo}}" /></div>
                <div class="margin_top" style="white-space:pre-wrap; font-weight:600; margin-top:5px">{{flight.airlineName}}</div>
                <div class="margin_top" style="margin-top:5px">{{flight.airlinePrefixCode}}{{flight.flightNumber}}</div>
              </div>
              <div class="padding_class2">
                <div class="margin_top" style="font-weight:600">{{flight.departureTime}}</div>
                <div class="margin_top">{{flight.fromIATACODE}}</div>
                <div class="margin_top">{{flight.departureDate | date:'fullDate'}}</div>
                <div class="margin_top" style="white-space:pre-wrap">{{flight.fromAirportName}}</div>
                <div class="margin_top" style="white-space:pre-wrap">Terminal:{{flight.departureTerminal}}</div>
              </div>
              <div class="margin_top_gif padding_class_gif"><img class="anim" src="assets/img/animation_fly.gif" /></div>
              <div class="padding_class3">
                <div class="margin_top" style="font-weight:600">{{flight.arrivalTime}}</div>
                <div class="margin_top">{{flight.toIATACODE}}</div>
                <div class="margin_top">{{flight.arrivalDate | date:'fullDate'}}</div>
                <div class="margin_top" style="white-space:pre-wrap">{{flight.toAirportName }}</div>
                <div class="margin_top" style="white-space:pre-wrap">Terminal:{{flight.arrivalTerminal }}</div>
              </div>
              <div class="padding_class4">
                <div class="margin_top">Cabin: {{flight.cabinClass}}</div>
                <div class="margin_top">RBD: {{flight.rbd}}</div>
                <div class="margin_top">SPNR: {{bookingInfo.supplierLocatorCode}}</div>
                <div class="margin_top">Status: <span style="font-weight:600">{{flight.flightStatus}}</span></div>
              </div>
            </div>
          </div>
        }

      </div>


      <div class="upper_row">
        <div class="inner_body card_width">
          <div class="cms_card-heading">
            @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==1) {
              <span>Current </span>
            }
            @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==2 && !buttonsHideIfEmiratesOccur) {
              <span>Old </span>
            }
            @if (bookingInfo.exchangeCheck && bookingInfo.exchangedBookingStatus==2 && buttonsHideIfEmiratesOccur) {
              <span>Initial </span>
              }Passengers
            </div>
            <table class="table ">
              <thead class="">
                <tr>
                  <th scope="col">Sector</th>
                  <th scope="col">Name</th>

                  <th scope="col">Type</th>
                  <th scope="col">E-Ticket #</th>
                  <th scope="col">CheckIn Baggage</th>
                  <th scope="col">Cabin Baggage</th>
                  <th scope="col">Status</th>
                  <th scope="col">Seat</th>
                  <th scope="col">Meal</th>
                </tr>
              </thead>
              <tbody>
                @for (passenger of passengerBaggage; track passenger; let i = $index) {
                  <tr>
                    <td style="font-weight:600">{{passenger.fromAirport}} To {{passenger.toAirport}}</td>
                    <td style="font-weight:600">
                      <div class="dx-field">
                        <p>
                          <a class="hovername" id="link3{{i}}"
                            (mouseenter)="toggleWithAnimationOptions(i)"
                          (mouseleave)="toggleWithAnimationOptions(i)"> {{passenger.firstName}} {{passenger.lastName}}</a>
                        </p>
                        <dx-popover target="#link3{{i}}"
                          position="top"
                          [width]="330"
                          [(visible)]="withAnimationOptionsVisible[i]">
                          <dxo-animation>
                            <dxo-show type="pop"
                              [from]="{ scale: 0 }"
                            [to]="{ scale: 1 }"></dxo-show>
                            <dxo-hide type="fade" [from]="1" [to]="0"></dxo-hide>
                          </dxo-animation>
                          <div *dxTemplate="let data = model; of: 'content'">
                            <div class="popoverhead">
                              <span>
                                Passenger Details
                              </span>
                            </div>
                            <div class="popovertext">
                              <div>
                                Title: <span class="popoversubtext">{{passenger.title}}</span>
                              </div>
                              <div>
                                Mobile No: <span class="popoversubtext">{{passenger.mobile}}  {{passenger.mobileSecondary ? passenger.mobileSecondary : ""}}</span>
                              </div>
                              <div>
                                Email: <span class="popoversubtext">{{passenger.email}}</span>
                              </div>
                              <div>
                                Passport No: <span class="popoversubtext">{{passenger.passportno}}</span>
                              </div>
                              <div>
                                Passport Expiry: <span class="popoversubtext">{{passenger.passportexpiry}}</span>
                              </div>
                              <div>
                                Date Of Birth: <span class="popoversubtext">{{passenger.dob}}</span>
                              </div>
                              <div>
                                Gender: <span class="popoversubtext">{{passenger.gender}}</span>
                              </div>
                            </div>
                          </div>
                        </dx-popover>
                      </div>
                    </td>
                    <td>{{passenger.typeName}}</td>
                    <td>{{passenger.ticketNo}}</td>
                    <td>{{passenger.baggageCheckIn}}</td>
                    <td>{{passenger.baggageCabin}}</td>
                    <td>{{passenger.status}}</td>
                    <td>{{passenger.seatNum}}</td>
                    <td>{{passenger.meal}}</td>
                    <!--<td style="font-weight:600">{{passenger.firstName}} {{passenger.lastName}}</td>
                    <td *ngIf="passenger.passengerType == 1">Adult</td>
                    <td *ngIf="passenger.passengerType == 2">Child</td>
                    <td *ngIf="passenger.passengerType == 3">Infant</td>
                    <td>{{passenger.ticketNo}}</td>
                    <td>{{passenger.baggageCheckIn}}</td>
                    <td>{{passenger.baggageCabin}}</td>-->
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        @if (bookingInfo.exchangeCheck) {
          <div class="inner_body my-2">
            <div class="cms_card-heading">
              Exchanged Flights Details
            </div>
            @for (flight of ExchangenewsectorInfo; track flight; let i = $index) {
              <div>
                <div class="details_heading_topbar">
                  <div class="from-to">
                    <span style="letter-spacing:0.7px">
                      <i class="uil uil-plane head_icon"></i>
                      {{flight.fromAirport}} TO {{flight.toAirport}}
                    </span>
                  </div>
                  <div class="stops"><span style="letter-spacing:0.7px">{{flight.noOfStops}} Stop(s)</span></div>
                </div>
                <div class="details_heading">
                  <div class="padding_class1">
                    <div class="margin_top" style="margin-top:5px"><img style="max-width:90px;height:50px" src="assets/img/{{flight.airlineLogo}}" /></div>
                    <div class="margin_top" style="white-space:pre-wrap; font-weight:600; margin-top:5px">{{flight.airlineName}}</div>
                    <div class="margin_top" style="margin-top:5px">{{flight.airlinePrefixCode}}{{flight.flightNumber}}</div>
                  </div>
                  <div class="padding_class2">
                    <div class="margin_top" style="font-weight:600">{{flight.departureTime}}</div>
                    <div class="margin_top">{{flight.fromIATACODE}}</div>
                    <div class="margin_top">{{flight.departureDate | date:'fullDate'}}</div>
                    <div class="margin_top" style="white-space:pre-wrap">{{flight.fromAirportName}}</div>
                    <div class="margin_top" style="white-space:pre-wrap">Terminal:{{flight.departureTerminal}}</div>
                  </div>
                  <div class="margin_top_gif padding_class_gif"><img class="anim" src="assets/img/animation_fly.gif" /></div>
                  <div class="padding_class3">
                    <div class="margin_top" style="font-weight:600">{{flight.arrivalTime}}</div>
                    <div class="margin_top">{{flight.toIATACODE}}</div>
                    <div class="margin_top">{{flight.arrivalDate | date:'fullDate'}}</div>
                    <div class="margin_top" style="white-space:pre-wrap">{{flight.toAirportName }}</div>
                    <div class="margin_top" style="white-space:pre-wrap">Terminal:{{flight.arrivalTerminal }}</div>
                  </div>
                  <div class="padding_class4">
                    <div class="margin_top">Cabin: {{flight.cabinClass}}</div>
                    <div class="margin_top">RBD: {{flight.rbd}}</div>
                    <div class="margin_top">SPNR: {{bookingInfo.supplierLocatorCode}}</div>
                    <div class="margin_top">Status: <span style="font-weight:600">{{flight.flightStatus}}</span></div>
                  </div>
                </div>
              </div>
            }
          </div>
        }







        @if (bookingInfo.exchangeCheck) {
          <div class="upper_row">
            <div class="inner_body card_width">
              <div class="cms_card-heading">Exchanged Booking Passengers</div>
              <table class="table ">
                <thead class="">
                  <tr>
                    <th scope="col">Sector</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">E-Ticket #</th>
                    <th scope="col">CheckIn Baggage</th>
                    <th scope="col">Cabin Baggage</th>
                    <th scope="col">Status</th>
                    <th scope="col">Seat</th>
                    <th scope="col">Meal</th>
                  </tr>
                </thead>
                <tbody>
                  @for (passenger of bookingAllData$.exchangePassengerBaggage; track passenger; let i = $index) {
                    <tr>
                      <td style="font-weight:600">{{passenger.fromAirport}} To {{passenger.toAirport}}</td>
                      <td style="font-weight:600">
                        <div class="dx-field">
                          <p>
                            <a class="hovername" id="link3{{i}}"
                              (mouseenter)="toggleWithAnimationOptionsexchaned(i)"
                            (mouseleave)="toggleWithAnimationOptionsexchaned(i)"> {{passenger.firstName}} {{passenger.lastName}}</a>
                          </p>
                          <dx-popover target="#link3{{i}}"
                            position="top"
                            [width]="330"
                            [(visible)]="withAnimationOptionsVisibleexchange[i]">
                            <dxo-animation>
                              <dxo-show type="pop"
                                [from]="{ scale: 0 }"
                              [to]="{ scale: 1 }"></dxo-show>
                              <dxo-hide type="fade" [from]="1" [to]="0"></dxo-hide>
                            </dxo-animation>
                            <div *dxTemplate="let data = model; of: 'content'">
                              <div class="popoverhead">
                                <span>
                                  Passenger Details
                                </span>
                              </div>
                              <div class="popovertext">
                                <div>
                                  Mobile No: <span class="popoversubtext">{{passenger.mobile}}</span>
                                </div>
                                <div>
                                  Email: <span class="popoversubtext">{{passenger.email}}</span>
                                </div>
                                <div>
                                  Passport No: <span class="popoversubtext">{{passenger.passportno}}</span>
                                </div>
                                <div>
                                  Passport Expiry: <span class="popoversubtext">{{passenger.passportexpiry}}</span>
                                </div>
                                <div>
                                  Date Of Birth: <span class="popoversubtext">{{passenger.dob}}</span>
                                </div>
                                <div>
                                  Gender: <span class="popoversubtext">{{passenger.gender}}</span>
                                </div>
                              </div>
                            </div>
                          </dx-popover>
                        </div>
                      </td>
                      <td>{{passenger.typeName}}</td>
                      <td>{{passenger.ticketNo}}</td>
                      <td>{{passenger.baggageCheckIn}}</td>
                      <td>{{passenger.baggageCabin}}</td>
                      <td>{{passenger.status}}</td>
                      <td>{{passenger.seatNum}}</td>
                      <td>{{passenger.meal}}</td>
                      <!--<td style="font-weight:600">{{passenger.firstName}} {{passenger.lastName}}</td>
                      <td *ngIf="passenger.passengerType == 1">Adult</td>
                      <td *ngIf="passenger.passengerType == 2">Child</td>
                      <td *ngIf="passenger.passengerType == 3">Infant</td>
                      <td>{{passenger.ticketNo}}</td>
                      <td>{{passenger.baggageCheckIn}}</td>
                      <td>{{passenger.baggageCabin}}</td>-->
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }


        <div class="inner_body my-2">



          <div class="cms_card-heading">Supplier Remarks</div>

          <div class="d-flex justify-content-between align-items-baseline p-2">

            <div class="remarks d-flex justify-content-between">

              <!--<div style="font-weight:600">{{px.firstName}} {{px.lastName}}</div>-->
              <div class="remarks_sub">{{supplierRemarksSingle}}</div>
              <div class="remarks_sub">{{exchangedsupplieremarks}}</div>



              <!--<div class="remarks_sub" *ngIf="px.supplierRemarks.includes('GMT')">Issuance Expiry: {{px.supplierRemarks}}</div>-->

            </div>

            <hr />

            <div><p id="timer"></p></div>

          </div>

        </div>



        <div class="inner_body my-2">
          <div class="cms_card-heading"><i></i>Help & Support</div>
          <div class="support_details d-flex justify-content-between">
            <div class="contact_card">
              <span><img class="contact_icons" src="assets/img/smartphone30.png" /></span>
              <span class="info_name">Telephone : <span style="font-weight:600">{{agencyOnline.telephoneNumber}}</span></span>
            </div>
            <div class="contact_card">
              <span><img class="contact_icons" src="assets/img/envelope30.png" /></span>
              <span class="info_name">Email : <span style="font-weight:600">{{agencyOnline.emailAddress}}</span></span>
            </div>
          </div>
          <div class="marginbotoomcancel">
            <button class="cancelnewticketbutton" id="btnCancelTkt" (click)="cancelPopup(cancel)">Cancel</button>
          </div>
        </div>

      </div>

      <!--========================================== Response Dialogue =================================-->
      <!--<div id="myModal" class="">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <span class="modal-title"><i class="uil uil-comment news_bar_icons"></i></span>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">

            <div>
              <div class="main_noti" id="main_noti"></div>
            </div>

          </div>
        </div>
      </div>
    </div>-->

  </div>
  <div id="overlay"></div>
  <div class="error-dialogfor-ist ist-hide">
    <div class="ist-container">
      <p class="message-ist"></p>
      <button class="error-btn-ist" (click)="errorClose()">OK</button>
    </div>



  </div>


  <div id="myModalVoid" class="modal fade">

    <div class="modal-dialog">

      <div class="modal-content">

        <div class="modal-header">

          <span class="modal-title"><i class="uil uil-comment news_bar_icons"></i></span>

          <button type="button" class="close" data-dismiss="modal">&times;</button>

        </div>

        <div class="modal-body">



          <table class="table table-hover">

            <thead class="void_tab_head">

              <tr>

                <th scope="col">Passenger Name</th>

                <th scope="col">Type</th>

                <th scope="col">E-Ticket #</th>

                <th scope="col">Selection</th>

              </tr>

            </thead>

            <tbody class="void_tab_body">

              @for (passenger of voidPassengerInfo; track passenger; let y = $index) {
                <tr>
                  <td style="font-weight:500">
                    {{passenger.firstName}} {{passenger.lastName}}
                    @if (passenger.passengerType==3 && passenger.associatedAdult !=null) {
                      <span style="font-size:9px !important;color:var(--first-color-second)red">Associated: {{passenger.associatedAdult}}</span>
                    }
                  </td>
                  @if (passenger.passengerType == 1 ) {
                    <td>Adult</td>
                  }
                  @if (passenger.passengerType == 2 ) {
                    <td>Child</td>
                  }
                  @if (passenger.passengerType == 3) {
                    <td>Infant</td>
                  }
                  <td>{{passenger.ticketNo}}</td>
                  <td>
                    <label class="switch selectField">
                      <input type="checkbox" name="isSelected{{y}}" [(ngModel)]="passenger.isVoid" [disabled]="checkvoid" (change)="voidcheckpassenger(y)" [checked]="passenger.isVoid" />
                      <span></span>
                    </label>
                  </td>
                </tr>
              }

            </tbody>

          </table>

          <button class="save_but" (click)="voidTicket()">Void</button>
          <span style="margin-left:4px;color:red;font-weight:bold;font-size:13px" id="voidrequiredmsg"></span>

        </div>

      </div>

    </div>

  </div>
  <div>
    <ng-template #spprokmsg let-modal>

      <div class="modal-success_new new_class_pop">
        <div style="display: flex; align-items: center; justify-content: center; padding: 12px; ">
          <img class="sucesspopup_img" src="assets/img/icons8-info-94.png" />
        </div>
        <div style="display: flex; align-items: center; justify-content: center; padding: 5px; ">
          <p class="innerhtmlofmodal_new">{{supplierMsg}}</p>
        </div>
        <div style="display: flex; align-items: center; justify-content: center; padding: 5px; ">
          <button class="OKButton" (click)="modal.dismiss()">Ok</button>
        </div>

      </div>


    </ng-template>
  </div>


  <div class="easeoutin">
    <ng-template #issueticket let-modal>

      <div class="modal-success ">
        <img class="sucesspopup" src="assets/img/icons8-error.gif" />

        <p class="textpopupsuccess"> Are You Sure?</p>
        <p class="innerhtmlofmodal"> You Want To Issue Ticket?</p>
        <div class="marginbtnlft">
          <div>
            <!--<button class="yesButton" (click)="issueTicket(issueticketNoRight)">Yes, issue it!</button>-->
            <button class="yesButton" (click)="issueTicket(issueticketNoRight)">  {{ checkRightForRequestToIssue() ? 'Yes, issue it!' : 'Yes, request for issue it!' }}</button>
          </div>
          <div>
            <button class="noButton" (click)="modal.dismiss()">No</button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="easeoutin">
    <ng-template #repriceticket let-modal>

      <div class="modal-success ">
        <img class="sucesspopup" src="assets/img/icons8-error.gif" />

        <p class="textpopupsuccess"> Are You Sure?</p>
        <p class="innerhtmlofmodal"> You Want To Reprice Ticket?</p>
        <div class="marginbtnlft">
          <div>
            <button class="yesButton" (click)="repriceTicket()">Yes, reprice it!</button>
          </div>
          <div>
            <button class="noButton" (click)="modal.dismiss()">No</button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="easeoutin">
    <ng-template #addPassengerDetails let-modal>
      <div class="modal-success " style="width:max-content">
        <p class="textpopupsuccess"> Add Passenger details</p>
        <form class="noti col-sm-12 form-line-active">

          <div>
            @for (obj of bookingInfo.bookingPassengerInfoProperties; track obj; let i = $index) {
              <div class="forms_container_main infant_type">
                <div class="main_form">
                  <div class="row m-0 py-2">
                    <div class="col-sm-2 poisiton_Columns  px-1">
                      <input class="main_text-box" type="text" [(ngModel)]="obj.title" name="title{{i}}" readonly>
                    </div>
                    <div class="col-sm-4 poisiton_Columns  px-1">
                      <input class="main_text-box new_main_Text_Box " [(ngModel)]="obj.firstName" id="firstname{{i}}" name="firstName{{i}}" type="text" readonly />
                      <div>
                        <label for="" class="input_lab_first" id="firstlabel{{i}}">First Name</label>
                      </div>
                      <div>
                        <span class="first-required" id="messageFirstnameRquired{{i}}"></span>
                      </div>
                    </div>
                    <div class="col-sm-4 poisiton_Columns  px-1">
                      <input class="main_text-box" type="text" [(ngModel)]="obj.lastName" id="lastname{{i}}" name="lastName{{i}}" readonly>
                      <div>
                        <label for="" class="input_lab_first" id="lastlabel{{i}}">Last Name</label>
                      </div>
                      <div>
                        <span class="first-required" id="messagelastnameRquired{{i}}"></span>
                      </div>
                    </div>
                  </div>
                  <div class="row m-0 align-items-end">
                    <div class="col-sm-4 pb-2 px-1 poisiton_Columns">
                      <input class="main_text-box"
                        type="text"
                        [(ngModel)]="obj.passportNumber"
                        (change)="onPassportNumberChange(i)"
                        id="passportnum{{i}}"
                        name="passportNumber{{i}}">
                        <label class="input_lab_first" id="ppnlabel{{i}}">Passport No</label>
                        <!--<span class="first-required"></span>-->
                        <div>
                          <span class="first-required" id="messagePPNRquired{{i}}"></span>
                        </div>
                      </div>
                      <div class="col-sm-4 pb-2 px-1 poisiton_Columns mb-4">
                        <input class="main_text-box new_main_Text_Box"
                          type="date"
                          [ngModel]="formatDate(obj.passportValidTo)"
                          (ngModelChange)="parseDate($event, obj)"
                          id="pasportvalidto{{i}}"
                          name="passportValidTo{{i}}">
                          <label class="input_lab_first" id="pexplabel{{i}}">Passport Expiry</label>
                          <span class="first-required" id="messagePassExpRquired{{i}}"></span>
                        </div>
                        <div class="col-sm-4 pb-2 px-1 poisiton_Columns">
                          <ng-select class="country-issuance-Class   countryOfIssueclass" [items]="countryList"
                            id="countryborderClass{{i}}"
                            bindLabel="countryName" bindValue="code"
                            [searchable]="true"
                            (click)="CountryofIsuuance_Focus_Input(i)"
                            (blur)="Coi_Focus(i)"
                            placeholder="Select"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="obj.countryOfIssuance">
                          </ng-select>
                          <div>
                            <label for="" class="input_lab_first countryOfIssueclass" id="countryLabel{{i}}">Country of Issuance</label>
                          </div>
                          <div>
                            <span class="first-required" id="messageCoIRquired{{i}}"></span>
                          </div>
                        </div>
                        @if (showNationalityFor1GGDS_1GNDc) {
                          <div class="col-sm-4  px-1">
                            <ng-select class="nationalityClass  "
                              id="nationcc{{i}}"
                              [items]="countryList"
                              placeholder="Select"
                              bindLabel="countryName" bindValue="code"
                              [searchable]="true"
                              (click)="Nation_Focus(i)"
                              (blur)="Coi_Focus(i)"
                              [ngModelOptions]="{standalone: true}"
                              [(ngModel)]="obj.paxNationality">
                            </ng-select>
                            <div>
                              <label for="" class="input_lab_first" id="nationLabel{{i}}">Nationality</label>
                            </div>
                            <div>
                              <span class="first-required" id="messageNationRquired{{i}}"></span>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="marginbtnlfttt">
                <div>
                  <button class="yesButton" (click)="CheckRequiredValidation()">Submit</button>
                </div>
                <div>
                  <button class="noButton" (click)="modal.dismiss()">No</button>
                </div>
              </div>
            </form>
          </div>
        </ng-template>
      </div>
      <div class="easeoutin">
        <ng-template #addServiceCharges let-modal>
          <div class="modal-success " style="width:max-content">
            <p class="textpopupsuccess"> Add Service Charges</p>
            <form class="noti col-sm-12 form-line-active">

              <div>
                <div class="forms_container_main infant_type">
                  <div class="main_form">
                    <div class="row m-0 py-2">

                      <div class="col-sm-4 poisiton_Columns  px-1">

                        <input class="main_text-box new_main_Text_Box " [(ngModel)]="bookingInfo.totalAmount" id="totalPurchaseAmount" name="totalPurchaseAmount" type="text" readonly />
                        <div>
                          <label for="" class="input_lab_first">Amount</label>
                        </div>


                      </div>
                      <div class="col-sm-4 poisiton_Columns  px-1">

                        <input class="main_text-box" type="text" [(ngModel)] ="serviceChargesPerPassenger" name="serviceChargesPerPassenger">
                        <div>
                          <label for="" class="input_lab_first" >Add Service Charges Per Passenger</label>
                        </div>
                      </div>
                      <div class="col-sm-4 poisiton_Columns px-1">
                        <input class="main_text-box"
                          type="text"
                          [(ngModel)]="totalSumAmount"
                          name="totalSumAmount"
                          readonly>
                          <div>
                            <label class="input_lab_first">Total Amount</label>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="marginbtnlfttt">
                  <div>
                    <button class="yesButton" (click)="applyServiceCharges()">Apply Service charges</button>
                  </div>
                  <div>
                    <button class="yesButton" (click)="PostInvoiceForBranches()" [disabled]="isPostingInvoice">Post Invoice</button>
                  </div>
                  <div>
                    <button class="noButton" (click)="modal.dismiss()">No</button>
                  </div>
                </div>
              </form>
            </div>
          </ng-template>
        </div>
        <div class="easeoutin">
          <ng-template #issueticketNoRight let-modal>
            <div class="modal-success ">
              <img class="sucesspopup" src="assets/img/icons8-error.gif" />
              <p class="textpopupsuccess"> Not Authorized!</p>
              <p class="innerhtmlofmodal"> You are not authorized to issue this airline, please contact administrator for more information.</p>
            </div>
          </ng-template>
        </div>
        <div class="easeoutin">
          <ng-template #cancel let-modal>

            <div class="modal-success ">
              <img class="sucesspopup" src="assets/img/badicon.gif" />

              <p class="textpopupsuccess"> Are You Sure?</p>
              <p class="innerhtmlofmodal"> You Won't be revert back!</p>
              <div class="marginbtnlft">
                <div>
                  <button class="yesButton" (click)="CancelButton()">Yes, Cancel it!</button>
                </div>
                <div>
                  <button class="noButton" (click)="modal.dismiss()">No</button>
                </div>
              </div>
            </div>


          </ng-template>
        </div>
        <div class="easeoutin">
          <ng-template #pnrtkt let-modal>

            <div class="modal-success ">
              <img class="sucesspopup" src="assets/img/icons8-error.gif" />

              <p class="textpopupsuccess"> Are You Sure?</p>
              <p class="innerhtmlofmodal"> You Want To Cancel PNR?</p>
              <div class="marginbtnlft">
                <div>
                  <button class="yesButton" (click)="cancelPNR()">Yes, cancel it!</button>
                </div>
                <div>
                  <button class="noButton" (click)="modal.dismiss()">No</button>
                </div>
              </div>
            </div>


          </ng-template>
        </div>
        <div class="easeoutin">
          <ng-template #voidtkt let-modal>

            <div class="modal-success ">
              <img class="sucesspopup" src="assets/img/icons8-error.gif" />

              <p class="textpopupsuccess"> Are You Sure?</p>
              <p class="innerhtmlofmodal"> You Want To Void Ticket?</p>
              <div class="marginbtnlft">
                <div>
                  <button class="yesButton" (click)="openVoidPop()">Yes, void it!</button>
                </div>
                <div>
                  <button class="noButton" (click)="modal.dismiss()">No</button>
                </div>
              </div>
            </div>


          </ng-template>


          <div id="myModalRefund" class="modal fade">

            <div class="modal-dialog">

              <div class="modal-content">

                <div class="modal-header">

                  <span class="modal-title"><i class="uil uil-comment news_bar_icons"></i></span>

                  <button type="button" class="close" data-dismiss="modal">&times;</button>

                </div>

                <div class="modal-body">



                  <table class="table table-hover">

                    <thead class="void_tab_head">

                      <tr>

                        <th scope="col">Passenger Name</th>

                        <th scope="col">Type</th>

                        <th scope="col">E-Ticket #</th>

                        <th scope="col">Selection</th>

                      </tr>

                    </thead>

                    <tbody class="void_tab_body">
                      @for (passenger of bookingrefundinfo.bookingPassengerInfoProperties; track passenger; let k = $index) {
                        <tr>
                          <td style="font-weight:500">{{passenger.firstName}} {{passenger.lastName}}</td>
                          @if (passenger.passengerType == 1) {
                            <td>Adult</td>
                          }
                          @if (passenger.passengerType == 2) {
                            <td>Child</td>
                          }
                          @if (passenger.passengerType == 3) {
                            <td>Infant</td>
                          }
                          <td>{{passenger.ticketNo}}</td>
                          <td>
                            <label class="switch selectField">
                              <input type="checkbox" name="isrfndSelected{{k}}" id="rfndbtn{{k}}" [disabled]="passenger.disabledrefund" [(ngModel)]="passenger.isRefund" [checked]="passenger.isRefund" />
                              <span></span>
                            </label>
                          </td>
                        </tr>
                      }
                      <!--<tr *ngFor="let passengerRfnd of bookingPassengerInfoRfnd; let k = index">

                      <td style="font-weight:500">{{passengerRfnd.firstName}} {{passengerRfnd.lastName}}</td>

                      <td *ngIf="passengerRfnd.passengerType == 1">Adult</td>

                      <td *ngIf="passengerRfnd.passengerType == 2">Child</td>

                      <td *ngIf="passengerRfnd.passengerType == 3">Infant</td>

                      <td>{{passengerRfnd.ticketNo}}</td>

                      <td>

                        <label class="switch selectField">

                          <input type="checkbox" name="isrfSelected{{k}}" [(ngModel)]="passenger.isRefund" [checked]="passenger.isRefund" />

                          <span></span>

                        </label>

                      </td>

                    </tr>-->

                  </tbody>

                </table>




                <button class="save_but" id="refundonline" (click)="RefundTicket()">Refund</button>

              </div>

            </div>

          </div>

          <
          s=

        </div>

        <
        s=
    ="

    <div class="easeoutin">
      <ng-template #rfndtkt let-modal>

        <div class="modal-success ">
          <img class="sucesspopup" src="assets/img/icons8-error.gif" />

          <p class="textpopupsuccess">Are You Sure?</p>
          <p class="innerhtmlofmodal"> You Want To Refund Ticket?</p>
          <div class="marginbtnlft">
            <div>
              <button class="yesButton" (click)="RefundTicketPopup()">Yes, Refund it!</button>
            </div>
            <div>
              <button class="noButton" (click)="modal.dismiss()">No</button>
            </div>
          </div>
        </div>


      </ng-template>
    </div>
    <p-dialog header="Refund Passenger" [(visible)]="refundPassengerPop" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
      <p-table [value]="bookingrefundinfo.bookingPassengerInfoProperties" [tableStyle]="{ 'min-width': '30rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Passenger Name</th>
            <th>Type</th>
            <th>Selection</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-passenger>
          <tr>
            <td>
              <div style="display:flex;flex-direction:column">
                {{passenger.firstName}} {{passenger.lastName}}
                @if (passenger.passengerType==3 && passenger.associatedAdult !=null) {
<span style="font-size:9px !important;color:orangered">Associated: {{passenger.associatedAdult}}</span>
}

              </div>
            </td>

            @if (passenger.passengerType == 1) {
<td>Adult</td>
}

            @if (passenger.passengerType == 2) {
<td>Child</td>
}

            @if (passenger.passengerType == 3) {
<td>Infant</td>
}
            <td>
              <p-toggleswitch [disabled]="passenger.disabledrefund" [(ngModel)]="passenger.isRefund" name="refundps" (onChange)="Refundcheckpassenger(passenger)"></p-toggleswitch>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div style="padding:2px 6px 2px 6px;width:100%;display:flex;">
        <div style=" width:50%">
          <span id="selectatleastoneremove" style="color:red;font-size:12px;"></span>
        </div>
        <div style="width:50%;text-align:right">
          <button class="button-remove" (click)="beforeemiratesChangeCheck(refundCheckBookingType)">Refund</button>
        </div>
      </div>
    </p-dialog>
    <p-dialog header="Void Passenger" [(visible)]="voidPassengerPop" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
      <p-table [value]="voidPassengerInfo" [tableStyle]="{ 'min-width': '30rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Passenger Name</th>
            <th>Type</th>
            <th>Selection</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-passenger>
          <tr>
            <td>
              <div style="display:flex;flex-direction:column">
                {{passenger.firstName}} {{passenger.lastName}}
                @if (passenger.passengerType==3 && passenger.associatedAdult !=null) {
<span style="font-size:9px !important;color:orangered">Associated: {{passenger.associatedAdult}}</span>
}

              </div>
            </td>

            @if (passenger.passengerType == 1) {
<td>Adult</td>
}

            @if (passenger.passengerType == 2) {
<td>Child</td>
}

            @if (passenger.passengerType == 3) {
<td>Infant</td>
}
            <td>
              <p-toggleswitch [(ngModel)]="passenger.isVoid" [disabled]="checkvoid" (change)="voidcheckpassenger(passenger)"></p-toggleswitch>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div style="padding:2px 6px 2px 6px;width:100%;display:flex;">
        <div style=" width:50%">
          <span id="selectatleastoneremove" style="color:red;font-size:12px;"></span>
        </div>
        <div style="width:50%;text-align:right">
          <button class="button-remove" (click)="beforeemiratesChangeCheck(voidCheckBookingType)">Void</button>
        </div>
      </div>
    </p-dialog>
  </div>




</main>

